export default __webpack_public_path__ + "static/media/whatnfm.1bad8547.jpeg";